import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useMutation } from '../../Shared/api';
import { useNotifier } from '../../Shared/Notifier/NotificationProvider';
import { useRouter } from '../router';
import { SharedProps } from '../types';
import Container from '../UI/Container';
import Layout from '../UI/Layout';
import { CharitySettingsLayout } from './CharitySettingsLayout';
import EditEventSettingsForm, { EditEventSettingsFormProps } from './EditEventSettingsForm';

export interface EventSettingsPageProps extends SharedProps {
  charity: EditEventSettingsFormProps['charity'];
}

export default function EventSettingsPage({
  charity,
}: EventSettingsPageProps) {
  const { t } = useTranslation();
  const { routes } = useRouter();
  const notifier = useNotifier();

  const [saveEventSettings, { errors, loading, formKey }] = useMutation(
    routes.save_event_settings(),
    {
      onSuccess: () => {
        notifier.notify(t('backend:event_settings_saved'));
      },
    }
  );

  return (
    <Container size="md" className="space-y-6">
      <EditEventSettingsForm
        charity={charity}
        onSubmit={saveEventSettings}
        serverErrors={errors}
        loading={loading}
        key={formKey}
      />
    </Container>
  );
}

EventSettingsPage.layout = (page: ReactNode) => <Layout><CharitySettingsLayout>{page}</CharitySettingsLayout></Layout>;
